module.exports = __webpack_public_path__ + "static/media/NeuropsychologicalAssessment  - Graphic.ad7d6764.svg";